import { render, staticRenderFns } from "./ProductPrice.yaml?vue&type=template&id=648e05f8&component"
import script from "./ProductPrice.yaml?vue&type=script&lang=ts&component"
export * from "./ProductPrice.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports